import { CircleCheck } from "lucide-react";
import { Checkbox } from "../ui/checkbox";

const ITEMS = [
  {
    key: "eligibility",
    tone: "border-scarlet/40 bg-scarlet/[0.04]",
    title: "Campaign eligibility attestation",
    body: "I am the enrolled student named above and the intended beneficiary of this campaign. I am personally creating and submitting this campaign. No parent, sibling, guardian, spouse, friend, classmate, teacher, employer, or other third party has created this campaign on my behalf. I understand that any account identified as having been created by someone other than the beneficiary student will be suspended immediately, and funds raised from donors who stated a non-binding preference for contributing toward the suspended campaign will be used to support other eligible campaigns.",
    link: { href: "/terms#campaign-eligibility", label: "Read the full Campaign Eligibility clause", cls: "text-scarlet" },
  },
  {
    key: "enrollment_consent",
    tone: "border-cobalt/40 bg-cobalt/[0.04]",
    title: "I consent to enrollment verification",
    body: "I authorize My Rich Aunt to verify my current enrollment status, including through the National Student Clearinghouse.",
  },
  {
    key: "student_cert",
    tone: "border-tangerine/40 bg-tangerine/[0.04]",
    title: "Student certification",
    body: "I am at least 18 years of age and currently enrolled as a student at an accredited college or university in the United States. I agree that any funds awarded to me through My Rich Aunt's supplemental educational grant program will be used exclusively to support education-related and student living costs while enrolled, which are not already covered by my financial aid package. I understand that My Rich Aunt does not require me to submit receipts for grants of $500 or less but relies on this legally binding certification for federal tax compliance.",
    link: { href: "/faq?group=students&open=expense-guidelines", label: "See the Expense Guidelines", cls: "text-tangerine" },
  },
];

export const AttestationsSection = ({ value, onChange, locked = false }) => {
  const checked = ITEMS.filter((i) => value?.[i.key]).length;
  const complete = checked === ITEMS.length;
  return (
    <div data-testid="attestations-group" className="space-y-4 rounded-lg border border-border bg-bone/40 p-5">
      <div className="flex items-baseline justify-between gap-4 border-b border-border/70 pb-3">
        <span className="text-[13px] font-semibold uppercase tracking-[0.22em] text-ink">Attestations</span>
        {complete ? (
          <span data-testid="attestations-count" className="inline-flex items-center gap-1.5 rounded-full bg-grass/15 px-2.5 py-0.5 text-[13px] font-semibold uppercase tracking-[0.14em] text-grass ring-1 ring-inset ring-grass/30">
            <CircleCheck className="h-3 w-3" strokeWidth={2} /> All 3 complete
          </span>
        ) : (
          <span data-testid="attestations-count" className="text-[13px] font-semibold uppercase tracking-[0.18em] text-olive">{checked} of 3 required</span>
        )}
      </div>
      {ITEMS.map((it) => (
        <label key={it.key} data-testid={`${it.key}-row`} className={`flex cursor-pointer items-start gap-3 rounded-lg border p-5 ${it.tone} ${locked ? "cursor-default opacity-90" : ""}`}>
          <Checkbox
            data-testid={`${it.key}-checkbox`}
            checked={Boolean(value?.[it.key])}
            disabled={locked}
            onCheckedChange={(v) => onChange({ ...value, [it.key]: Boolean(v) })}
            className="mt-0.5"
          />
          <span>
            <span className="block text-[13px] font-semibold text-ink">{it.title}</span>
            <span className="mt-1 block text-[13px] leading-relaxed text-olive">{it.body}</span>
            {it.link && (
              <a href={it.link.href} target="_blank" rel="noopener noreferrer" className={`mt-2 inline-block text-[13px] font-semibold uppercase tracking-[0.14em] underline underline-offset-2 hover:text-ink ${it.link.cls}`}>
                {it.link.label}
              </a>
            )}
          </span>
        </label>
      ))}
    </div>
  );
};
